<template>
    <div class="s3-browser">
        <div class="file-panel">
            <ul class="file-list">
                <li
                    v-for="(file, idx) in files"
                    :key="idx"
                    :class="{ active: selectedKey === file }"
                    @click="selectFile(file)"
                >
                    📄 {{ fileName(file) }}
                </li>
            </ul>
        </div>

        <div class="preview-panel">
            <div v-if="error" class="error">{{ error }}</div>
            <div v-if="loading" class="loading">Loading preview...</div>

            <div v-if="previewUrl && !loading" class="preview">
                <!-- Image Preview -->
                <img
                    v-if="previewType === 'image'"
                    :src="previewUrl"
                    class="preview-image"
                />

                <!-- PDF Preview -->
                <iframe
                    v-if="previewType === 'pdf'"
                    :src="previewUrl"
                    class="preview-pdf"
                ></iframe>

                <!-- Other file -->
                <div v-if="previewType === 'other'">
                    <p>No inline preview available.</p>
                </div>

                <div class="preview-actions">
                    <button @click="downloadFile">Download</button>
                </div>
            </div>

            <div v-if="!previewUrl && !loading && !error" class="no-selection">
                Click a file to preview
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "S3Browser",

    props: {
        applicationId: {
            type: [Number, String],
            default: null,
        },
        files: {
            type: Array,
            default: () => [],
        },
    },

    data() {
        return {
            previewUrl: null,
            previewType: null,
            selectedKey: null,
            loading: false,
            error: null,
        };
    },

    methods: {
        fileName(path) {
            return path.split("/").pop();
        },

        fileExtension(path) {
            return path.split(".").pop().toLowerCase();
        },

        async selectFile(filePath) {
            this.selectedKey = filePath;
            this.error = null;
            this.loading = true;
            this.previewUrl = null;

            const ext = this.fileExtension(filePath);

            if (["jpg", "jpeg", "png", "gif", "webp", "svg", "bmp"].includes(ext)) {
                this.previewType = "image";
            } else if (ext === "pdf") {
                this.previewType = "pdf";
            } else {
                this.previewType = "other";
            }

            try {
                const res = await fetch(
                    `/api/v1/admin/s3/url?key=${encodeURIComponent(filePath)}&token=${this.$auth.token()}`
                );
                if (!res.ok) throw new Error(`HTTP ${res.status}`);
                const data = await res.json();
                this.previewUrl = data.url;
            } catch (e) {
                this.error = "Failed to load preview: " + e.message;
            } finally {
                this.loading = false;
            }
        },

        downloadFile() {
            if (this.previewUrl) {
                window.open(this.previewUrl, "_blank");
            }
        },
    },
};
</script>

<style scoped>
.s3-browser {
    display: flex;
    gap: 20px;
    width: 100%;
}

.file-panel {
    min-width: 250px;
    border-right: 1px solid #ddd;
}

.file-list {
    list-style: none;
    padding: 0;
    margin: 0;
}

.file-list li {
    padding: 8px 10px;
    cursor: pointer;
    word-break: break-all;
}

.file-list li:hover {
    background: #f2f2f2;
}

.file-list li.active {
    background: #e6f0ff;
    font-weight: bold;
}

.preview-panel {
    flex: 1;
    min-width: 0;
}

.preview {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.preview-image {
    max-width: 100%;
    max-height: 500px;
    border: 1px solid #ccc;
    object-fit: contain;
}

.preview-pdf {
    width: 100%;
    height: 500px;
    border: 1px solid #ccc;
}

.preview-actions {
    margin-top: 8px;
}

.preview-actions button {
    padding: 6px 16px;
    cursor: pointer;
}

.error {
    color: #c00;
    margin-bottom: 8px;
}

.loading {
    color: #666;
    margin-bottom: 8px;
}

.no-selection {
    color: #999;
    padding: 20px 0;
}
</style>
